<template>
  <div class="loading" v-show="loading">
    <template v-if="loaded">
      <span class="text">已经到底了~</span>
    </template>
    <template v-else-if="loading">
      <mt-spinner type="fading-circle"></mt-spinner>
      <span class="text">加载中...</span>
    </template>
  </div>
</template>
<script>
export default {
  name: 'Loading',
  props: {
    loading: { type: Boolean, default: false },
    loaded: { type: Boolean, default: false }
  }
}
</script>
<style>
.loading {
  display: flex;
  padding: 0.2rem 0;
  align-items: center;
  justify-content: center;
}
.loading .text {
  padding-left: 0.1rem;
}
</style>
